import PropTypes from "prop-types";
import React, { useState, useContext, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import MenuCart from "./sub-components/MenuCart";
import { deleteFromCart, updateAllPrices } from "../../redux/actions/cartActions";
import StaticContent from "../../context/ContentContext";
import contentContext from "../../context/ContentContext";
import { productApi } from '../../helpers/product';

const IconGroup = ({
  currency,
  cartData,
  wishlistData,
  compareData,
  deleteFromCart,
  iconWhiteClass,
  updateAllPrices,
}) => {
  const [searchValue, setSearchValue] = useState()
  const { userData, storeData } = useContext(StaticContent)
  const selectedStore = useContext(contentContext);
  const handleClick = e => {
    if(e.currentTarget.nextSibling.classList.value === "shopping-cart-content") {
      getPriceFormula()
    }
    e.currentTarget.nextSibling.classList.add("active");
  };

  const history = useHistory()
  const cartModal = useRef()
  const userModal = useRef()

  const getPriceFormula = () => {
    const productIds = []
    for (let i = 0; i < cartData?.length; i += 1) {
      productIds.push(cartData[i].productId)
    }
    const uniqId = [...new Set(productIds)]
    if (selectedStore?.storeData) {
    productApi.getProductsList(0, 100, [{key: 'data.productData.productId', operation: 'eq', values: uniqId}], ['pricingManagement', 'productData.productId'], [],).then(response => {
      updateAllPrices({items: response.data.items, selectedStore: selectedStore?.storeData})
  })
}
}
  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };

  const topSearchHandle = (e) => {
    e.preventDefault()
    history.push(`/shop?s=${searchValue ?? ''}`)
  }
  const closeOpenMenus = (e)=>{
    if(cartModal.current && !cartModal.current.contains(e.target)){
      cartModal.current.classList.remove("active")
    }
}
const closeOpenUserMenus = (e)=>{
  if(userModal.current && !userModal.current.contains(e.target)){
    userModal.current.classList.remove("active")
  }
}
document.addEventListener('mousedown',closeOpenMenus)
document.addEventListener('mousedown',closeOpenUserMenus)
  return (
    <div
      className={`header-right-wrap ${iconWhiteClass ? iconWhiteClass : ""}`}
    >
      {storeData?.data?.isActive && (<><div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={e => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form action="#">
            <input type="text" placeholder="Search" onChange={(e) => setSearchValue(e.target.value)} />
            <button className="button-search" onClick={(e) => topSearchHandle(e)}>
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div>
      <div className="same-style">
        <Link to={process.env.PUBLIC_URL + "/pages/lightbulb"}>
          <i className="pe-7s-light" />
        </Link>
      </div>
      <div className="same-style account-setting">
        <button
          className="account-setting-active"
          onClick={e => handleClick(e)}
        >
          <i className="pe-7s-user-female" />
        </button>
        <div className="account-dropdown" ref={userModal}>
          <ul>
            {(!userData || !localStorage.getItem('access_token')) && <><li>
              <Link to={process.env.PUBLIC_URL + "/login-register"}>Login</Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/login-register?tab=register"}>
                Register
              </Link>
            </li></>}
            {userData && localStorage.getItem('access_token')?.length > 0 && <><li>
              <Link to={process.env.PUBLIC_URL + "/my-account"}>
                my account
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/order-details"}>
                my orders
              </Link>
            </li>
            <li>
              <Link onClick={() => { 
                localStorage.removeItem('access_token')
                window.location= '/'
            }}>
                logout
              </Link>
            </li></>}
          </ul>
        </div>
      </div>
      <div className="same-style header-wishlist">
        <Link to={process.env.PUBLIC_URL + "/wishlist"}>
          <i className="pe-7s-like" />
          <span className="count-style">
            {wishlistData && wishlistData.length ? wishlistData.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style cart-wrap d-none d-lg-block">
        <button className="icon-cart" onClick={e => handleClick(e)}>
          {/* <i className="pe-7s-shopbag" /> */}
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/icon-img/shopping-cart.png`}
            alt=""
            style={{
              width: 24,
              height: 24,
              aspectRatio: 1
            }} 
          />
          <span className="count-style">
            {cartData && cartData.length ? cartData.length : 0}
          </span>
        </button>
        {/* menu cart */}
        <MenuCart
          cartData={cartData}
          currency={currency}
          deleteFromCart={deleteFromCart}
          cartModal={cartModal}
        />
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartData && cartData.length ? cartData.length : 0}
          </span>
        </Link>
      </div>
      {userData && storeData?.data?.storeType === 'Balance' && <div className="hide-on-mobile" style={{ whiteSpace: 'nowrap', marginLeft: '25px' }}>
        <b><span style={{ fontSize: '15px' }}>{`Balance: $${userData?.config?.balance ? userData?.config?.balance : '0'}`}</span></b>
      </div>}
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div></>)}
    </div>
  );
};

IconGroup.propTypes = {
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  iconWhiteClass: PropTypes.string,
  deleteFromCart: PropTypes.func,
  wishlistData: PropTypes.array
};

const mapStateToProps = state => {
  return {
    currency: state.currencyData,
    cartData: state.cartData,
    wishlistData: state.wishlistData,
    compareData: state.compareData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteFromCart: (item, addToast) => {
      dispatch(deleteFromCart(item, addToast));
    },
    updateAllPrices: (item, addToast) => {
      dispatch(updateAllPrices(item, addToast));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IconGroup);
